var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { RenderIf } from 'syf-component-library/ui/atoms';
import { StyledCell, StyledColumnHeader, StyledInvisibleRowGroup, StyledRow, StyledRowGroup, StyledTable, StyledTableTitle } from './subcomponents';
var TableList = function (_a) {
    var children = _a.children, header = _a.header, hideHeader = _a.hideHeader, title = _a.title, banner = _a.banner;
    var StyledHeaderGroup = hideHeader
        ? StyledInvisibleRowGroup
        : StyledRowGroup;
    return (_jsxs(_Fragment, { children: [_jsx(RenderIf, { condition: Boolean(title), children: _jsx(StyledTableTitle, { children: title }) }), _jsx(RenderIf, { condition: Boolean(banner), children: banner }), _jsxs(StyledTable, { children: [_jsx(RenderIf, { condition: Boolean(header), children: _jsx(StyledHeaderGroup, { "aria-hidden": "true", children: _jsx(StyledRow, { children: header }) }) }), _jsx(StyledRowGroup, { children: children })] })] }));
};
TableList.Cell = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (_jsx(StyledCell, __assign({}, rest, { children: children })));
};
TableList.ColumnHeader = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (_jsx(StyledColumnHeader, __assign({}, rest, { children: children })));
};
TableList.Row = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (_jsx(StyledRow, __assign({}, rest, { children: children })));
};
TableList.RowGroup = function (_a) {
    var children = _a.children, rest = __rest(_a, ["children"]);
    return (_jsx(StyledRowGroup, __assign({}, rest, { children: children })));
};
export default TableList;
//# sourceMappingURL=index.js.map